/**
 * Catálogo de marcas y etiquetas de conexión para impresoras térmicas POS.
 * Exporta listas para selects (sin lógica de red).
 */

export const POS_PRINTER_BRANDS = [
  { value: "imin", label: "Imin" },
  { value: "epson", label: "Epson" },
  { value: "xprinter", label: "Xprinter" },
  { value: "rongta", label: "Rongta" },
  { value: "star", label: "Star Micronics" },
  { value: "bixolon", label: "Bixolon" },
  { value: "generic", label: "Otra / genérica ESC/POS" },
] as const;

export type PosPrinterBrandValue = (typeof POS_PRINTER_BRANDS)[number]["value"];

export const POS_CONNECTION_TYPE_LABELS: Record<
  "network" | "bluetooth_spp" | "usb",
  { label: string; description: string }
> = {
  network: {
    label: "Red / Wi‑Fi",
    description:
      "Impresora en la misma red local (mismo router/Wi‑Fi que el teléfono, tablet o PC).",
  },
  bluetooth_spp: {
    label: "Bluetooth",
    description:
      "Empareja la impresora en Ajustes de Android; luego elige el dispositivo en la lista.",
  },
  usb: {
    label: "USB (OTG)",
    description:
      "Cable USB‑C/micro con adaptador OTG. Busca la impresora y pulsa Conectar para autorizar.",
  },
};
